export default function getResource(label, vars = []) {
    const resources = {
        orderNumber: 'Numéro de commande'
    };
    return resources[label];
}
